import { CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  QueryList,
  signal,
  ViewChildren,
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { FilterListByStringPipe } from "@shared/pipes/filter-list-by-string.pipe";
import { Checkbox, CheckboxModule } from "primeng/checkbox";
import { TableModule } from "primeng/table";
import { SkeletonModule } from "primeng/skeleton";
import { SelectButtonModule } from 'primeng/selectbutton';
import { SelectChangeEvent, SelectModule } from 'primeng/select';

import { TachographListDownloadDeadlineComponent } from "../download-deadline/tachograph-list-download-deadline.component";
import { CurrentFileStatusOnListComponent } from "../current-file-status-on-list/current-file-status-on-list.component";
import { TachScheduleFileStatus } from "@src/app/enum/tacho.enum";
import { TachographFileStatusEmptyListComponent } from "../empty-list/tachograph-file-status-empty-list.component";
import { ICompanyCard } from "@src/app/interfaces/api/files-ddd.interface";

const imports = [
  CommonModule,
  TableModule,
  TranslateModule,
  FilterListByStringPipe,
  CheckboxModule,
  FormsModule,
  TachographListDownloadDeadlineComponent,
  CurrentFileStatusOnListComponent,
  SkeletonModule,
  SelectButtonModule,
  TachographFileStatusEmptyListComponent,
  SelectModule,
];

@Component({
  selector: "app-tachograph-files-list",
  standalone: true,
  imports,
  providers: [FilterListByStringPipe],
  templateUrl: "./tachograph-files-list.component.html",
  styleUrls: ["./tachograph-files-list.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TachographFilesListComponent {
  private readonly translate = inject(TranslateService);

  @ViewChildren("checkboxItem") private checkboxItemsRefs: QueryList<Checkbox>;

  @Input() public isDriverMode: boolean;
  @Input() public isLoading: boolean;
  @Input() public listHeight: string;
  @Input() public searchValueControl: string;
  @Input() public isCheckedAll: boolean;
  @Input() public list: any[] = [];
  @Input() public selectedItems: any[] = [];
  @Input() public companyCards: ICompanyCard[] = [];

  @Output() private forceFile$: EventEmitter<{ item: any, button: HTMLButtonElement }> = new EventEmitter();
  @Output() private onToggleSelectedAll$: EventEmitter<boolean> = new EventEmitter();
  @Output() private onSelectItem$: EventEmitter<any[]> = new EventEmitter();
  @Output() private onChangeDownloadMode$: EventEmitter<{ value: boolean, item: any }> = new EventEmitter();
  @Output() public openFiles$: EventEmitter<string> = new EventEmitter();
  @Output() public onChangeCompanyCard$: EventEmitter<{ value: ICompanyCard | null; item: any }> = new EventEmitter();

  public readonly TACHO_FILE_STATUS = TachScheduleFileStatus;

  public stateOptions: any[] = [{ label: this.translate.instant('automatic'), value: true },{ label: this.translate.instant('manual'), value: false }];

  public onChangeValueCheckedAll(value: boolean): void {
    this.checkboxItemsRefs.forEach((el) => el.writeValue(value));
    this.onToggleSelectedAll$.emit(value);
  }

  public onCheckedItem(data: Checkbox, item: any): void {
    setTimeout(() => {
      const list = [...this.selectedItems];

      if (data.checked) {
        list.push(item);
        this.onSelectItem$.emit(list);
        return;
      }

      const index = list.findIndex((el) => el.VehicleId === item.VehicleId);
      list.splice(index, 1);
      this.onSelectItem$.emit(list);
    }, 0);
  }

  public forceFile(button: HTMLButtonElement, item: any): void {
    this.forceFile$.emit({ button, item });
  }

  public onChangeDownloadMode(value: boolean, item: any): void {
    this.onChangeDownloadMode$.emit({ value, item });
  }

  public onChangeCompanyCard(event: SelectChangeEvent, item: any): void {
    this.onChangeCompanyCard$.emit({
      value: this.companyCards.find(card => card.Number === event.value) as ICompanyCard | null,
      item,
    });
  }

}
